// Centre pane — the poster cover of the selected title, vertically centred on
// a --bg background. Falls back to a dim film-frame glyph when the title has
// no cover (has_cover false or the image 404s), and to an empty-state prompt
// when nothing is selected.

import { useEffect, useState } from "react";

import type { TitleDetail } from "../api/types";
import { Logo } from "./Logo";

import "./CoverPane.css";

export function CoverPane({
  imdbId,
  title,
}: {
  imdbId: string | null;
  title: TitleDetail | undefined;
}) {
  const [imgFailed, setImgFailed] = useState(false);

  // A new selection gets a fresh chance at loading its cover.
  useEffect(() => {
    setImgFailed(false);
  }, [imdbId]);

  if (!imdbId) {
    return (
      <div className="cover-pane cover-pane--empty">
        <span className="cover-pane__glyph" aria-hidden>
          <Logo size={96} />
        </span>
        <div className="cover-pane__hint">select a title from the explorer</div>
      </div>
    );
  }

  const noCover = imgFailed || (title != null && !title.has_cover);

  if (noCover) {
    return (
      <div className="cover-pane cover-pane--empty">
        <span className="cover-pane__glyph" aria-hidden>
          <Logo size={96} />
        </span>
        <div className="cover-pane__hint">no cover</div>
      </div>
    );
  }

  return (
    <div className="cover-pane">
      <img
        key={imdbId}
        className="cover-pane__img"
        src={`/api/covers/${imdbId}`}
        alt={title ? `${title.title} cover` : "cover"}
        onError={() => setImgFailed(true)}
      />
    </div>
  );
}
